import * as idEndpoints from './id';
import { root, id } from './playlists';

export const playlists = {
  ...root,
  id: {
    ...id,
    ...idEndpoints,
  },
};
